import { render, staticRenderFns } from "./SponsorView.vue?vue&type=template&id=2189ef8f"
import script from "./SponsorView.vue?vue&type=script&lang=js"
export * from "./SponsorView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports